function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import classnames from 'classnames';
import flow from 'lodash.flow';
import noop from 'lodash.noop';
import React, { useCallback } from 'react';
import FormLabelGroup from "../Form/FormLabelGroup";
import Input from "../Input/Input";
import Col from "../Layout/Col";
import Row from "../Layout/Row";
import CountryInput from "./CountryInput";
import StateInput from "./StateInput";

var readEvent = function readEvent(e) {
  var target = e.target;
  return _defineProperty2({}, target.name, target.value);
};

var getValue = function getValue(field, source) {
  var fieldValue = source[field];

  if (typeof fieldValue === 'undefined' || fieldValue === null) {
    return null;
  }

  return fieldValue;
};

var defaultProps = {
  className: '',
  defaultValue: {},
  disabled: false,
  error: {},
  hints: {},
  labels: {
    address1: 'Address',
    address2: 'Address 2',
    city: 'City',
    state: 'State',
    postal: 'Zip',
    countryCode: 'Country'
  },
  inputName: {
    address1: 'address1',
    address2: 'address2',
    city: 'city',
    state: 'state',
    postal: 'postal',
    countryCode: 'countryCode'
  },
  onBlur: noop,
  onChange: noop,
  showCountry: true,
  showLabels: false,
  value: {}
};

var AddressInput = function AddressInput(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? defaultProps.className : _ref$className,
      compact = _ref.compact,
      countries = _ref.countries,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? defaultProps.defaultValue : _ref$defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? defaultProps.disabled : _ref$disabled,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? defaultProps.error : _ref$error,
      _ref$hints = _ref.hints,
      hints = _ref$hints === void 0 ? defaultProps.hints : _ref$hints,
      id = _ref.id,
      _ref$inputName = _ref.inputName,
      inputName = _ref$inputName === void 0 ? defaultProps.inputName : _ref$inputName,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? defaultProps.labels : _ref$labels,
      _ref$onBlur = _ref.onBlur,
      _onBlur = _ref$onBlur === void 0 ? defaultProps.onBlur : _ref$onBlur,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? defaultProps.onChange : _ref$onChange,
      _ref$showCountry = _ref.showCountry,
      showCountry = _ref$showCountry === void 0 ? defaultProps.showCountry : _ref$showCountry,
      _ref$showLabels = _ref.showLabels,
      showLabels = _ref$showLabels === void 0 ? defaultProps.showLabels : _ref$showLabels,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? defaultProps.value : _ref$value;

  var valueChanged = useCallback(function (update) {
    onChange(_objectSpread(_objectSpread({}, value), update));
  }, [onChange, value]);
  var getValues = useCallback(function (field) {
    var gotValue = getValue(field, value);

    if (gotValue !== null) {
      return {
        value: gotValue
      };
    }

    var gotDefaultValue = getValue(field, defaultValue);

    if (gotDefaultValue !== null) {
      return {
        defaultValue: gotDefaultValue
      };
    }

    return {};
  }, [value, defaultValue]);
  var inputId = id || 'addressInput';
  var address1Id = "".concat(inputId, "_address1");
  var address2Id = "".concat(inputId, "_address2");
  var cityId = "".concat(inputId, "_city");
  var stateId = "".concat(inputId, "_state");
  var postalId = "".concat(inputId, "_postal");
  var countryCodeId = "".concat(inputId, "_countryCode");
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    id: id
  }, /*#__PURE__*/React.createElement(FormLabelGroup, {
    label: labels.address1,
    inputId: address1Id,
    srLabel: !showLabels,
    feedback: error.address1,
    hint: hints.address1,
    stacked: true
  }, /*#__PURE__*/React.createElement(Input, _extends({
    autoComplete: "address-line1",
    id: address1Id,
    name: inputName.address1,
    type: "text",
    placeholder: labels.address1
  }, getValues(inputName.address1), {
    invalid: !!error.address1,
    onBlur: function onBlur() {
      return _onBlur(inputName.address1);
    },
    onChange: flow([readEvent, valueChanged]),
    disabled: disabled
  }))), /*#__PURE__*/React.createElement(FormLabelGroup, {
    label: labels.address2,
    inputId: address2Id,
    srLabel: !showLabels,
    feedback: error.address2,
    hint: hints.address2,
    stacked: true
  }, /*#__PURE__*/React.createElement(Input, _extends({
    autoComplete: "address-line2",
    id: address2Id,
    name: inputName.address2,
    type: "text",
    placeholder: labels.address2
  }, getValues(inputName.address2), {
    invalid: !!error.address2,
    onBlur: function onBlur() {
      return _onBlur(inputName.address2);
    },
    onChange: flow([readEvent, valueChanged]),
    disabled: disabled
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "g-0"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: compact ? undefined : 6,
    xs: 12,
    className: compact ? undefined : 'pe-sm-3'
  }, /*#__PURE__*/React.createElement(FormLabelGroup, {
    rowClassName: classnames({
      'mb-sm-0': !showCountry && !compact
    }),
    feedback: error.city,
    hint: hints.city,
    label: labels.city,
    inputId: cityId,
    srLabel: !showLabels,
    stacked: true
  }, /*#__PURE__*/React.createElement(Input, _extends({
    autoComplete: "address-level2",
    id: cityId,
    type: "text",
    name: inputName.city,
    placeholder: labels.city
  }, getValues(inputName.city), {
    invalid: !!error.city,
    onBlur: function onBlur() {
      return _onBlur(inputName.city);
    },
    onChange: flow([readEvent, valueChanged]),
    disabled: disabled
  })))), /*#__PURE__*/React.createElement(Col, {
    md: compact ? undefined : 2,
    sm: compact ? undefined : 3,
    xs: 4,
    className: "pe-3"
  }, /*#__PURE__*/React.createElement(FormLabelGroup, {
    rowClassName: classnames({
      'mb-0': !showCountry
    }),
    feedback: error.state,
    hint: hints.state,
    label: labels.state,
    inputId: stateId,
    srLabel: !showLabels,
    stacked: true
  }, /*#__PURE__*/React.createElement(StateInput, _extends({
    autoComplete: "address-level1",
    className: "w-100",
    countries: countries,
    id: stateId,
    name: inputName.state,
    placeholder: labels.state
  }, getValues(inputName.state), {
    invalid: !!error.state,
    onBlur: function onBlur() {
      return _onBlur(inputName.state);
    },
    onChange: function onChange(state) {
      valueChanged(_defineProperty2({}, inputName.state, state));
    },
    disabled: disabled
  })))), /*#__PURE__*/React.createElement(Col, {
    md: compact ? undefined : 4,
    sm: compact ? undefined : 3,
    xs: 8
  }, /*#__PURE__*/React.createElement(FormLabelGroup, {
    rowClassName: classnames({
      'mb-0': !showCountry
    }),
    label: labels.postal,
    inputId: postalId,
    srLabel: !showLabels,
    feedback: error.postal,
    hint: hints.postal,
    stacked: true
  }, /*#__PURE__*/React.createElement(Input, _extends({
    autoComplete: "postal-code",
    id: postalId,
    type: "text",
    name: inputName.postal,
    placeholder: labels.postal
  }, getValues(inputName.postal), {
    invalid: !!error.postal,
    onBlur: function onBlur() {
      return _onBlur(inputName.postal);
    },
    onChange: flow([readEvent, valueChanged]),
    disabled: disabled
  }))))), showCountry && /*#__PURE__*/React.createElement(FormLabelGroup, {
    feedback: error.countryCode,
    hint: hints.countryCode,
    rowClassName: "mb-0",
    label: labels.countryCode,
    inputId: countryCodeId,
    srLabel: !showLabels,
    stacked: true
  }, /*#__PURE__*/React.createElement(CountryInput, _extends({
    autoComplete: "country",
    className: "w-100",
    id: countryCodeId,
    name: inputName.countryCode,
    placeholder: labels.countryCode
  }, getValues(inputName.countryCode), {
    invalid: !!error.countryCode,
    onBlur: function onBlur() {
      return _onBlur(inputName.countryCode);
    },
    onChange: function onChange(countryCode) {
      valueChanged(_defineProperty2({}, inputName.countryCode, countryCode));
    },
    disabled: disabled
  }))));
};

AddressInput.displayName = "AddressInput";
export default AddressInput;